import React, { Component } from "react";
import LineChart from "../../components/common/Charts/lineChart.js";
import MixBarCharts from "../../components/common/Charts/mixBarCharts.js";
// import BarCharts from "../../components/common/Charts/barChart.js";
import DoughnutChart from "../../components/common/Charts/doughnut.js";

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler,
} from 'chart.js';
import PieChartWithCenterValue from "../../components/common/Charts/pieChartWithCenterValue.js";
import PolarAreaChart from "../../components/common/Charts/polarAreaChart.js";
import AccountServices from "../../services/axioServices/apiServices/AccountServices.js";
import { type } from "@testing-library/user-event/dist/type/index.js";
import ProductionServices from "../../services/axioServices/apiServices/ProductionServices.js";
import SwalServices from "../../services/swalServices/SwalServices.js";
import DashboardServices from "../../services/axioServices/apiServices/DashboardServices.js";
import { color } from "chart.js/helpers";
import { text } from "@fortawesome/fontawesome-svg-core";
import BarCharts from "../../components/common/Charts/barChart.js";
import { faBoxesStacked, faFileContract, faSitemap, faWarehouse } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FinancealYearStartDateEndDate } from "../../utils/FinancialYearStartDateEndDate.js";
import MultiSelectDropdown from "../../components/dropdown/MultiSelectDropdown.js";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.accountServices = new AccountServices();
        this.productionServices = new ProductionServices();
        this.SwalServices = new SwalServices();
        this.dashboardServices = new DashboardServices();
        this.state = {
            isLoading: false,
            bankWiseReportList: [],
            productionData: [],
            topSellingProductList: [],
            topActiveClientList: [],
            monthlySales: [],
            salesData: [],
            purchaseData: [],
            labelforSalesAndPurchase: [],
            chartList: [
                { label: "Sales vs Purchase", value: 0 },
                { label: "GST Sales vs Purchase", value: 1 },
            ],
            dashboardDetails: {
                chartId: 0,
            },
            validState: {
                isValid: true,
                error: {},
            },
        }
    }
    componentDidMount() {
        this.getMonthlySalesAndPurchase();

    }
    getMonthlySalesAndPurchase = () => {
        this.setState({ isLoading: true }, () => {
            this.dashboardServices.getMonthlySalesAndPurchase().then((response) => {
                if (response.statusCode === 200 && response.responseData != null) {
                    const labels = response.responseData.map((item) => item.month);
                    const salesData = response.responseData.map((item) => item.sales);
                    const purchaseData = response.responseData.map((item) => item.purchase);
                    this.setState({ labelforSalesAndPurchase: labels, salesData: salesData, purchaseData: purchaseData }, () => {
                        this.getAllProductionPlanningNumber();
                    })
                } else {
                    this.getAllProductionPlanningNumber();
                    this.SwalServices.Error(
                        response.Message
                    );
                }
            })
        })
    }
    getAllProductionPlanningNumber = () => {
        this.dashboardServices.getAllProductionPlanningNumber().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                this.setState({ productionData: response.responseData }, () => {
                    this.getTopSellingProducts();
                })
            } else {
                this.getTopSellingProducts();
                this.SwalServices.Error(
                    response.Message
                );
            }
        });
    };
    getTopSellingProducts = () => {
        this.dashboardServices.getTopSellingProducts().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                this.setState({ topSellingProductList: response.responseData }, () => {
                    this.getAllBankWiseCashBankBookReport();
                })
            } else {
                this.getAllBankWiseCashBankBookReport();
                this.SwalServices.Error(
                    response.Message
                );
            }
        })
    }
    getAllBankWiseCashBankBookReport = () => {
        this.setState({ tableStatus: "Loading..." }, () => {
            let dates = FinancealYearStartDateEndDate()
            let request = [dates.startDate, dates.endDate]
            this.accountServices.getAllBankWiseCashBankBookReport(request).then((response) => {
                if (response.statusCode === 200 && response.responseData != null) {
                    this.setState({ bankWiseReportList: response.responseData }, () => {
                        this.getTopActiveClients();
                    })
                } else {
                    this.getTopActiveClients();
                    this.SwalServices.Error(response.Message)
                }
            });
        })
    }


    getTopActiveClients = () => {
        this.dashboardServices.getTopActiveClients().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                this.setState({ topActiveClientList: response.responseData, isLoading: false })

            } else {
                this.setState({ isLoading: false })
                this.SwalServices.Error(
                    response.Message
                );
            }
        })
    }
    handleClick = (path) => {
        window.location.href = path
    };

    setFilterParameters = (selected, drpIdentity, section) => {
        let details = this.state.dashboardDetails;
        details[drpIdentity] = selected.value;
        this.setState({ dashboardDetails: details });
    };

    render() {
        const salePurchaseOptions = {
            responsive: true,
            maintainAspectRatio: false,
            interaction: {
                mode: "index",
                intersect: false,
            },
            plugins: {
                legend: {
                    position: "bottom",
                    labels: {
                        usePointStyle: true,
                        pointStyle: "circle",
                        boxWidth: 8,
                        boxHeight: 8,
                        padding: 16,
                        font: {
                            size: 13,
                            family: "Inter, sans-serif",
                            weight: "500",
                        },
                        color: "#374151",
                    },
                },
                tooltip: {
                    backgroundColor: "#ffffff",
                    titleColor: "#111827",
                    bodyColor: "#374151",
                    borderColor: "rgba(0,0,0,0.08)",
                    borderWidth: 1,
                    titleFont: { size: 12, weight: "700" },
                    bodyFont: { size: 10 },
                    padding: 10,
                    cornerRadius: 10,
                    boxPadding: 6,
                    displayColors: true,
                    callbacks: {
                        label: function (context) {
                            const value = context.raw ?? 0;
                            if (typeof value === "number") {
                                return `₹${value.toLocaleString()}`;
                            }
                            return `₹0`;
                        },
                    },
                },
            },
            scales: {
                x: {
                    offset: true,
                    grid: {
                        color: "rgba(0, 0, 0, 0.025)",
                        drawTicks: false,
                        drawBorder: false,
                    },
                    ticks: {
                        color: "#374151",
                        padding: 6,
                    },
                    stacked: false,
                },
                y: {
                    grid: {
                        color: "rgba(0, 0, 0, 0.025)",
                        drawTicks: false,
                        drawBorder: false,
                    },
                    ticks: {
                        color: "#374151",
                        callback: function (value) {
                            if (Number.isFinite(value)) return `₹${value.toLocaleString()}`;
                            return value;
                        },
                    },
                    beginAtZero: true,
                    stacked: false,
                },
            },
        };
        const salePurchaseData = {
            labels: this.state.labelforSalesAndPurchase,
            datasets: [
                {
                    label: "Sale Amount",
                    data: this.state.salesData,
                    backgroundColor: "#4578F9",
                    borderColor: "#4578F9",
                    borderWidth: 0,
                    borderRadius: 6,
                    barPercentage: 0.6,
                    categoryPercentage: 0.6,
                    maxBarThickness: 24,
                    hoverBackgroundColor: "#4578F9",
                },
                {
                    label: "Purchase Amount",
                    data: this.state.purchaseData,
                    backgroundColor: "#97B7FF",
                    borderColor: "#97B7FF",
                    borderWidth: 0,
                    borderRadius: 6,
                    barPercentage: 0.6,
                    categoryPercentage: 0.6,
                    maxBarThickness: 24,
                    hoverBackgroundColor: "#97B7FF",
                },
            ],
        };

        const CASH_PALETTE = [
            '#2452C7',
            '#4578F9',
            '#7FA5FF',
            '#B3C9FF',
            '#E6EEFF',
        ];

        const cashbankBookOptions = {
            responsive: true,
            maintainAspectRatio: false,
            cutout: '68%',
            animation: { animateRotate: true, easing: 'easeOutCubic' },



            plugins: {
                legend: {
                    display: false,
                    position: 'bottom',
                    labels: {
                        usePointStyle: true,
                        pointStyle: 'circle',
                        boxWidth: 8,
                        boxHeight: 8,
                        padding: 10,
                        font: {
                            size: 13,
                            family: 'Inter, sans-serif',
                            weight: '500',
                        },
                        color: '#374151',
                    },
                },
                tooltip: {
                    backgroundColor: "#ffffff",
                    titleColor: "#111827",
                    bodyColor: "#374151",
                    borderColor: "rgba(0,0,0,0.08)",
                    borderWidth: 1,
                    titleFont: { size: 12, weight: "700" },
                    bodyFont: { size: 10 },
                    padding: 10,
                    cornerRadius: 10,
                    boxPadding: 6,
                    displayColors: false,
                    callbacks: {
                        label: (ctx) => {
                            const label = ctx.label ?? '';
                            const value = ctx.parsed ?? 0;
                            const total = ctx.chart.data.datasets[0].data.reduce((a, b) => a + b, 0) || 1;
                            const percent = ((value / total) * 100).toFixed(1);
                            return `${label}: ${value.toLocaleString()} • ${percent}%`;
                        },
                    },
                },
            },

            interaction: {
                intersect: false,
                mode: 'nearest',
            },
        };

        const cashbankBookData = {
            labels: this.state.bankWiseReportList.map((item) => item.shortName),
            datasets: [
                {
                    data: this.state.bankWiseReportList.map((item) => item.closingBalance),
                    backgroundColor: CASH_PALETTE,
                    borderRadius: 8,
                    hoverOffset: 2,
                },
            ],
        };

        const YELLOW_PALETTE = [
            '#FFBC11',
            '#FFC933',
            '#FFD65C',
            '#FFE188',
            '#FBF3DF'
        ];

        const topSellingProductOptions = {
            cutout: '65%',
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    display: false,
                    position: 'bottom',
                    align: 'center',
                    labels: {
                        usePointStyle: true,
                        pointStyle: 'circle',
                        boxWidth: 8,
                        boxHeight: 8,
                        padding: 12,
                        font: {
                            size: 13,
                            family: 'Inter, sans-serif',
                            weight: '600',
                        },
                        color: '#374151', // neutral text
                    },
                },
                tooltip: {
                    backgroundColor: "#ffffff",
                    titleColor: "#111827",
                    bodyColor: "#374151",
                    borderColor: "rgba(0,0,0,0.08)",
                    borderWidth: 1,
                    titleFont: { size: 12, weight: "700" },
                    bodyFont: { size: 10 },
                    padding: 10,
                    cornerRadius: 10,
                    boxPadding: 6,
                    displayColors: false,

                    callbacks: {
                        label: (ctx) => {
                            const label = ctx.label ?? "";
                            const value = ctx.parsed ?? 0;
                            const percent = (
                                (value / ctx.chart._metasets[0].total) *
                                100
                            ).toFixed(1);

                            return `${label}: ${value.toLocaleString()} • ${percent}%`;
                        },
                    },
                },
            },
            hoverOffset: 10,
            animation: {
                animateRotate: true,
                easing: 'easeOutCirc',
            },
        };

        const centerTextPlugin = {
            id: 'centerText',
            beforeDraw: (chart) => {
                const { width, height, ctx } = chart;
                ctx.save();

                const cx = width / 2;
                const cy = height / 2;
                const radius = Math.min(width, height) * 0.18;

                const grad = ctx.createRadialGradient(cx, cy, radius * 0.2, cx, cy, radius);
                grad.addColorStop(0, 'rgba(255,188,17,0.18)');
                grad.addColorStop(1, 'rgba(255,188,17,0)');

                ctx.beginPath();
                ctx.fillStyle = grad;
                ctx.arc(cx, cy, radius, 0, Math.PI * 2);
                ctx.fill();
                ctx.closePath();

                ctx.font = '600 12px Inter, sans-serif';
                ctx.fillStyle = '#6B7280';
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.fillText('Total', cx, cy - 16);

                const total = chart.data.datasets[0].data.reduce((a, b) => a + b, 0);
                ctx.font = '700 20px Inter, sans-serif';
                ctx.fillStyle = '#111827';
                ctx.fillText(total.toLocaleString(), cx, cy + 8);

                ctx.restore();
            },
        };
        const topSellingProductData = {
            labels: this.state.topSellingProductList.map(item => item.itemName),
            datasets: [
                {
                    data: this.state.topSellingProductList.map(item => item.totalQty),
                    backgroundColor: YELLOW_PALETTE,
                    borderRadius: 8,
                    hoverOffset: 2,
                }
            ]
        };

        const topActiveClientData = {
            labels: this.state.topActiveClientList.map((item) => item.partyName),
            datasets: [
                {
                    data: this.state.topActiveClientList.map((item) => item.grandTotal),
                    backgroundColor: [
                        '#4578F9',
                        '#FFBC11',
                        '#43B430',
                        '#FF7A33',
                        '#C3B1E1',
                    ],
                    borderWidth: 0,
                    hoverOffset: 12,
                    borderRadius: 0,
                },
            ],
        };
        const topActiveClientOptions = {
            responsive: true,
            plugins: {
                legend: {
                    display: false,
                    position: 'bottom',
                    labels: {
                        usePointStyle: true,
                        pointStyle: 'circle',
                        boxWidth: 8,
                        boxHeight: 8,
                        padding: 14,
                        font: {
                            size: 13,
                            family: 'Inter, sans-serif',
                            weight: '500',
                        },
                        color: '#374151',
                    },
                },
                tooltip: {
                    backgroundColor: "#ffffff",
                    titleColor: "#111827",
                    bodyColor: "#374151",
                    borderColor: "rgba(0,0,0,0.08)",
                    borderWidth: 1,
                    titleFont: { size: 12, weight: "700" },
                    bodyFont: { size: 10 },
                    padding: 10,
                    cornerRadius: 10,
                    boxPadding: 6,
                    displayColors: true,
                    callbacks: {
                        label: function (context) {
                            const value = context.raw !== undefined ? context.raw : context.parsed;
                            return typeof value === 'number'
                                ? `₹${value.toLocaleString()}`
                                : '₹0';
                        },
                    },
                },
            },
            scales: {
                r: {
                    grid: { color: '#E5E7EB' },
                    angleLines: { color: '#E5E7EB' },
                    ticks: {
                        backdropColor: 'transparent',
                        color: '#6B7280',
                        font: { size: 12, family: 'Inter, sans-serif' },
                        callback: function (value) {
                            return '₹' + Number(value).toLocaleString();
                        },
                    },
                },
            },
        };

        const gstSalesPurchaseData = {
            labels: this.state.labelforSalesAndPurchase,
            datasets: [
                {
                    label: "GST Sales",
                    data: this.state.salesData,
                    borderColor: "#22C55E",
                    backgroundColor: (context) => {
                        const chart = context.chart;
                        const { ctx, chartArea } = chart;
                        if (!chartArea) return "rgba(34,197,94,0.12)";
                        const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
                        gradient.addColorStop(0, "rgba(34,197,94,0.28)");
                        gradient.addColorStop(0.6, "rgba(34,197,94,0.06)");
                        gradient.addColorStop(1, "rgba(34,197,94,0)");
                        return gradient;
                    },
                    tension: 0.42,
                    fill: true,
                    pointRadius: 0,
                    pointHoverRadius: 6,
                    pointHoverBackgroundColor: "#22C55E",
                    pointHoverBorderColor: "#fff",
                    pointHoverBorderWidth: 2,
                    borderWidth: 2.5,
                },
                {
                    label: "GST Purchase",
                    data: this.state.purchaseData,
                    borderColor: "#F97316",
                    backgroundColor: (context) => {
                        const chart = context.chart;
                        const { ctx, chartArea } = chart;
                        if (!chartArea) return "rgba(249,115,22,0.12)";
                        const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
                        gradient.addColorStop(0, "rgba(249,115,22,0.28)");
                        gradient.addColorStop(0.6, "rgba(249,115,22,0.06)");
                        gradient.addColorStop(1, "rgba(249,115,22,0)");
                        return gradient;
                    },
                    tension: 0.42,
                    fill: true,
                    pointRadius: 0,
                    pointHoverRadius: 6,
                    pointHoverBackgroundColor: "#F97316",
                    pointHoverBorderColor: "#fff",
                    pointHoverBorderWidth: 2,
                    borderWidth: 2.5,
                },
            ],
        };

        const gstSalesPurchaseOptions = {
            responsive: true,
            maintainAspectRatio: false,
            interaction: { mode: "index", intersect: false },
            plugins: {
                legend: { display: false },
                tooltip: {
                    backgroundColor: "#ffffff",
                    titleColor: "#111827",
                    bodyColor: "#374151",
                    borderColor: "rgba(0,0,0,0.08)",
                    borderWidth: 1,
                    titleFont: { size: 12, weight: "700" },
                    bodyFont: { size: 10 },
                    padding: 10,
                    cornerRadius: 10,
                    boxPadding: 6,
                    displayColors: true,
                    callbacks: {
                        label: (ctx) => ` ₹${(ctx.raw ?? 0).toLocaleString()}`,
                    },
                },
            },
            scales: {
                x: {
                    grid: { color: "rgba(0,0,0,0.04)", drawBorder: false },
                    ticks: { color: "#6B7280", font: { size: 12 } },
                    border: { display: false },
                },
                y: {
                    beginAtZero: true,
                    grid: { color: "rgba(0,0,0,0.04)", drawBorder: false },
                    border: { display: false },
                    ticks: {
                        color: "#6B7280",
                        font: { size: 12 },
                        callback: (v) => `₹${v.toLocaleString()}`,
                    },
                },
            },
        };

        const productionPlanning = this.state.productionData.productionPlanningEntries === 0 ? 0 : this.state.productionData.productionPlanningEntries;
        const productionRequisition = this.state.productionData.productionRequisitionEntries === 0 ? 0 : this.state.productionData.productionRequisitionEntries;
        const packingRequisition = this.state.productionData.productionPackingRequisitionEntries === 0 ? 0 : this.state.productionData.productionPackingRequisitionEntries;
        const batchClearing = this.state.productionData.productionPendingBatchesEntries === 0 ? 0 : this.state.productionData.productionPendingBatchesEntries;

        return (
            <>
                {this.state.isLoading ?
                    <div className="flex items-center justify-center h-full bg-white" style={{ height: 'calc(100vh - 45px)' }}>
                        <img src="/pills.gif" alt="Loading..." className="w-[100px] h-[100px]" />
                    </div>
                    :
                    <div className="dashboard grid grid-cols-4 gap-5">
                        <div className="production-cards grid grid-cols-2 gap-5 col-span-2">
                            <div className="card bg-white rounded-[15px] p-5 shadow-custom-shadow2 relative cursor-pointer hover:shadow-none hover:bg-[#e7f0ff] hover:text-blue" onClick={() => this.handleClick("/ProductionPlanningEntry")}>
                                <span className="text-[14px] font-medium">Production Planning</span>
                                <p className="text-[32px] font-semibold mt-[8px]">{productionPlanning}</p>
                                <div className="trend flex items-center justify-center gap-[8px] mt-[5px] text-[12px] w-[40px] h-[40px] bg-blue rounded-[8px] absolute bottom-5 right-5">
                                    <FontAwesomeIcon icon={faSitemap} className="w-[25px] h-[25px] text-white" />
                                </div>

                            </div>
                            <div className="card bg-white rounded-[15px] p-5 shadow-custom-shadow2 relative cursor-pointer hover:bg-[#fbf3dfd6] hover:shadow-none hover:text-[#eca900]" onClick={() => this.handleClick("/ProductionRequisition")}>
                                <span className="text-[14px] font-medium">Production Requisition</span>
                                <p className="text-[32px] font-semibold mt-[8px]">{productionRequisition}</p>
                                <div className="trend flex items-center justify-center gap-[8px] mt-[5px] text-[12px] w-[40px] h-[40px] bg-yellow rounded-[8px] absolute bottom-5 right-5">
                                    <FontAwesomeIcon icon={faFileContract} className="w-[25px] h-[25px] text-white" />
                                </div>

                            </div>
                            <div className="card bg-white rounded-[15px] p-5 shadow-custom-shadow2 relative cursor-pointer hover:bg-[#43b4301f] hover:shadow-none hover:text-green" onClick={() => this.handleClick("/PackingRequisition")}>
                                <span className="text-[14px] font-medium">Packing Requisition</span>
                                <p className="text-[32px] font-semibold mt-[8px]">{packingRequisition}</p>
                                <div className="trend flex items-center justify-center gap-[8px] mt-[5px] text-[12px] w-[40px] h-[40px] bg-green rounded-[8px] absolute bottom-5 right-5">
                                    <FontAwesomeIcon icon={faBoxesStacked} className="w-[25px] h-[25px] text-white" />
                                </div>

                            </div>
                            <div className="card bg-white rounded-[15px] p-5 shadow-custom-shadow2 relative cursor-pointer hover:bg-[#ff7a3321] hover:shadow-none hover:text-[#FF7A33]" onClick={() => this.handleClick("/BatchClearingEntry")}>
                                <span className="text-[14px] font-medium">Pending Batches</span>
                                <p className="text-[32px] font-semibold mt-[8px]">{batchClearing}</p>
                                <div className="trend flex items-center justify-center gap-[8px] mt-[5px] text-[12px] w-[40px] h-[40px] bg-[#FF7A33] rounded-[8px] absolute bottom-5 right-5">
                                    <FontAwesomeIcon icon={faWarehouse} className="w-[25px] h-[25px] text-white" />
                                </div>

                            </div>
                        </div>
                        <div className="pie-charts col-span-2 grid grid-cols-2 gap-5">
                            <div className="selling-products bg-white rounded-[15px] p-5 shadow-custom-shadow2">
                                <span className="text-[16px] font-medium">Top Selling Products</span>
                                <DoughnutChart
                                    data={topSellingProductData}
                                    options={topSellingProductOptions}
                                    plugins={[centerTextPlugin]}
                                />
                            </div>
                            <div className="cash-book bg-white rounded-[15px] p-5 shadow-custom-shadow2">
                                <span className="text-[16px] font-medium">Cash/Bank Book Status</span>
                                <DoughnutChart
                                    data={cashbankBookData}
                                    options={cashbankBookOptions}
                                    plugins={[centerTextPlugin]}
                                />
                            </div>
                        </div>
                        <div className="bottom-charts flex col-span-4 gap-5">
                            <div className="bar-chart bg-white rounded-[15px] p-5 shadow-custom-shadow2 w-[60%] flex flex-col">
                                <div className="flex items-center justify-between gap-5 mb-4">
                                    <span className="text-[16px] font-medium">
                                        {this.state.dashboardDetails.chartId === 0 ? "Sales vs Purchase (Monthly)" : "GST Sales vs Purchase (Monthly)"}
                                    </span>
                                    <div className="flex items-center gap-4">

                                        <MultiSelectDropdown
                                            drpIdentity="chartId"
                                            options={this.state.chartList}
                                            className={`w-[300px] ${this.state.validState?.error?.chartId ? "errorInput" : ""}`}
                                            closeMenuOnSelect={true}
                                            hideSelectedOptions={false}
                                            onChange={(selected) =>
                                                this.setFilterParameters(selected, "chartId")
                                            }
                                            allowSelectAll={false}
                                            value={this.state.chartList.filter(
                                                (party) =>
                                                    party.value === this.state.dashboardDetails.chartId
                                            )}
                                        />
                                    </div>
                                </div>

                                <div style={{ position: "relative", height: "280px", width: "100%" }}>
                                    {this.state.dashboardDetails.chartId === 0 ? (
                                        <BarCharts data={salePurchaseData} options={salePurchaseOptions} />
                                    ) : (
                                        <LineChart data={gstSalesPurchaseData} options={gstSalesPurchaseOptions} />
                                    )}
                                </div>
                            </div>
                            <div className="polar-chart bg-white rounded-[15px] p-5 shadow-custom-shadow2 w-[40%]">
                                <span className="text-[16px] font-medium">Top Active Clients by Purchase Value</span>
                                <PolarAreaChart
                                    data={topActiveClientData}
                                    options={topActiveClientOptions}
                                />
                            </div>
                        </div>
                    </div>
                }

            </>
        );

    }
}

export default Dashboard;